module.exports = __webpack_public_path__ + "img/crz850.ebb14ccf.png";